var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('subproducto-form',{attrs:{"idBusiness":_vm.idBusiness,"idSubproducto":_vm.idSubproducto,"filtro":_vm.filtro,"pag":_vm.pag,"idProveedor":_vm.idProveedor,"ultimaCategoria":_vm.ultimaCategoria,"ultimoProveedor":_vm.ultimoProveedor,"SpProv":_vm.SpProv,"NomProveedor":_vm.NomProveedor,"ultimaCasa":_vm.ultimaCasa}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2754110","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Configuracion/Subproductos/Subproducto.vue
// module id = 6T9j
// module chunks = 4